<template>
  <div class="preheaders">
    <aside class="preheader"
      v-for="(item, index) in messages"
      :key="index"
      :class="{'is-closed': !item.isShow}"
      :style="{'background-color': item.bgColor, 'color': item.textColor}"
      v-show="!item.inner || (item.inner && isLogined)"
    >
      <div class="container">
        <div class="preheader__text" v-html="item.message"></div>
        <button class="preheader__close" @click="close(index)">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.41427 7.99994L15.7071 1.70689C16.0976 1.31639 16.0976 0.683131 15.7071 0.292878C15.3166 -0.0976255 14.6836 -0.0976255 14.2931 0.292878L8 6.58568L1.70715 0.292878C1.31665 -0.0976255 0.683386 -0.0976255 0.29288 0.292878C-0.0976263 0.683381 -0.0976263 1.31664 0.29288 1.70689L6.58598 7.99994L0.29288 14.293C-0.0976263 14.6835 -0.0976263 15.3167 0.29288 15.707C0.488133 15.9023 0.744137 16 0.999891 16C1.25564 16 1.5119 15.9023 1.70715 15.707L8 9.4142L14.2931 15.707C14.4884 15.9023 14.7444 16 15.0001 16C15.2559 16 15.5121 15.9023 15.7071 15.707C16.0976 15.3165 16.0976 14.6832 15.7071 14.293L9.41427 7.99994Z" :fill="item.textColor"/>
          </svg>
        </button>
      </div>
    </aside>
  </div>
</template>
<script>
  export default {
    methods: {
      close (index) {
        this.$store.commit('preheaders/close', index);
        requestAnimationFrame(() => {
          setTimeout(() => {
            this.$root.$emit('preheader-closed')
          }, 300)
        })

      }
    },
    computed: {
      messages () {
        return this.$store.getters['preheaders/getAll'];
      },
      isLogined () {
        return !!Object.keys(this.$store.state.users.user).length
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/sass/grid';
// Preheader
.preheader {
  left: 0;
  top: 0;
  width: 100%;
  height: 0px;
  z-index: 9999999;
  background-color: #E6A23C;
  color: white;
  overflow: hidden;
  animation: SlideDown .2s ease forwards;
  position: relative;
  z-index: 2;

  // &:not(.is-closed) + &:not(.is-closed){border-top: 1px solid rgba(#000,.2);}
  &.is-closed{animation: SlideUp .2s ease forwards;}

  .container{
    max-width: $width-xl;
    width: initial;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
    &:before,&:after{display: none;}
  }

  &__text {
    font-weight: 300;
    margin-left: 10px;
  }
  &__close{
    background-color: transparent;
    border: none;
    outline: none;
    width: 35px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    &:before{display: none;}
    svg{fill: #fff;}
    @media (min-width: $width-md) {
      margin-right: 6px;
    }
    @media (min-width: $width-xl) {
      margin-right: 12px;
    }
    @media (max-width: $width-sm) {
      margin-right: -1px;
    }
  }

  a {
    color: inherit;
    opacity: 0.8;
    text-decoration: underline;
  }
}

@media screen and (max-width:768px) {
  .preheader{min-height: initial !important;}
}

@keyframes SlideDown{
  from{height: 0;}
  to{height: 40px;}
}
@keyframes SlideUp{
  from{height: 40px;}
  to{height: 0px;}
}
</style>